import { render, staticRenderFns } from "./editGateway.vue?vue&type=template&id=1a4cb303&scoped=true&"
import script from "./editGateway.vue?vue&type=script&lang=js&"
export * from "./editGateway.vue?vue&type=script&lang=js&"
import style0 from "./editGateway.vue?vue&type=style&index=0&id=1a4cb303&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4cb303",
  null
  
)

export default component.exports